module.exports = __webpack_public_path__ + "brandon_light-webfont.5ea712a7ee0bb849f0f1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_light-webfont.woff
// module id = 939
// module chunks = 7